function Header() {
    return (
        <header className="container justify-center b-bg">
            <div className="logo">
                <h1 className="logo-title">Company</h1>
            </div>
        </header>
    );
}

export default Header;